<template>
  <div id="app">
    <button @click="count++" v-text="count"></button>
  </div>
</template>

<script>

export default {
  name: 'app',
  data(){
    return {
      count: 0
    }
  }
}
</script>

<style>
#app {
  text-align: center;
}
button {
  width: 200px;
  height: 300px;
  font-size: 32px;
}
</style>
